export { default } from './comparisonFilters';



// WEBPACK FOOTER //
// ./src/pages/DataCenter/Parent/ComparisonFilters/index.ts